import isSubset from '../../utils/isSubset';
import logger from "../../utils/logger";
import reset from '../../api-utils/reset';
import selectionLevel from '../../api-utils/selectionLevel';
import showUserErrors from '../../api-utils/showUserErrors';
export default function get() {
  var _this = this;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    keys: false
  };

  // get collection
  this.getCollection = function () {
    var collectionName = _this.collectionName;
    var orderByProperty = _this.orderByProperty;
    var orderByDirection = _this.orderByDirection;
    var limitBy = _this.limitBy;
    var collection = [];
    return _this.lf[collectionName].iterate(function (value, key) {
      var collectionItem = {};

      if (!options.keys) {
        collectionItem = value;
      } else {
        collectionItem = {
          key: key,
          data: value
        };
      }

      collection.push(collectionItem);
    }).then(function () {
      var logMessage = "Got \"".concat(collectionName, "\" collection"); // orderBy

      if (orderByProperty) {
        logMessage += ", ordered by \"".concat(orderByProperty, "\"");

        if (!options.keys) {
          collection.sort(function (a, b) {
            return a[orderByProperty].toString().localeCompare(b[orderByProperty].toString());
          });
        } else {
          collection.sort(function (a, b) {
            return a.data[orderByProperty].toString().localeCompare(b.data[orderByProperty].toString());
          });
        }
      }

      if (orderByDirection == 'desc') {
        logMessage += " (descending)";
        collection.reverse();
      } // limit


      if (limitBy) {
        logMessage += ", limited to ".concat(limitBy);
        collection = collection.splice(0, limitBy);
      }

      logMessage += ":";
      logger.log.call(_this, logMessage, collection);
      reset.call(_this);
      return collection;
    });
  }; // get document


  this.getDocument = function () {
    var collectionName = _this.collectionName;
    var docSelectionCriteria = _this.docSelectionCriteria;
    var collection = [];
    var document = {}; // get document by criteria

    _this.getDocumentByCriteria = function () {
      return _this.lf[collectionName].iterate(function (value, key) {
        if (isSubset(value, docSelectionCriteria)) {
          collection.push(value);
        }
      }).then(function () {
        if (!collection.length) {
          logger.error.call(_this, "Could not find Document in \"".concat(collectionName, "\" collection with criteria: ").concat(JSON.stringify(docSelectionCriteria)));
        } else {
          document = collection[0];
          logger.log.call(_this, "Got Document with ".concat(JSON.stringify(docSelectionCriteria), ":"), document);
          reset.call(_this);
          return document;
        }
      });
    }; // get document by key


    _this.getDocumentByKey = function () {
      return _this.lf[collectionName].getItem(docSelectionCriteria).then(function (value) {
        document = value;

        if (document) {
          logger.log.call(_this, "Got Document with key ".concat(JSON.stringify(docSelectionCriteria), ":"), document);
        } else {
          logger.error.call(_this, "Could not find Document in \"".concat(collectionName, "\" collection with Key: ").concat(JSON.stringify(docSelectionCriteria)));
        }

        reset.call(_this);
        return document;
      }).catch(function (err) {
        logger.error.call(_this, "Could not find Document in \"".concat(collectionName, "\" collection with Key: ").concat(JSON.stringify(docSelectionCriteria)));
        reset.call(_this);
      });
    };

    if (typeof docSelectionCriteria == 'object') {
      return _this.getDocumentByCriteria();
    } else {
      return _this.getDocumentByKey();
    }
  }; // check for user errors


  if (!(typeof options == 'object' && options instanceof Array == false)) {
    this.userErrors.push('Data passed to .get() must be an object. Not an array, string, number or boolean. The object must contain a "keys" property set to true or false, e.g. { keys: true }');
  } else {
    if (!options.hasOwnProperty('keys')) {
      this.userErrors.push('Object passed to get() method must contain a "keys" property set to boolean true or false, e.g. { keys: true }');
    } else {
      if (typeof options.keys !== 'boolean') {
        this.userErrors.push('Property "keys" passed into get() method must be assigned a boolean value (true or false). Not a string or integer.');
      }
    }
  }

  if (!this.userErrors.length) {
    var currentSelectionLevel = selectionLevel.call(this);

    if (currentSelectionLevel == 'collection') {
      return this.getCollection();
    } else if (currentSelectionLevel == 'doc') {
      return this.getDocument();
    }
  } else {
    showUserErrors.call(this);
    return null;
  }
}